import { AxiosResponse } from "axios";
import { ReactNode, useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import FormInPhieuDialog from "./components/PrintDialogBase64ToPdf";
import CustomIconButton from "../custom-icon-button/CustomIconButton";

 type ButtonInBase64ToPdfProps<T> = {
  label?: ReactNode;
  className?: string;
  keyOpenPhieuIn?: string;
  setKeyOpenPhieuIn?: (data: string) => void;
  isIcon?: boolean;
  disabled?: boolean;
  srcBase64?: string;
  fileName?: string;
};

const ButtonInBase64ToPdf = <T extends object>({
  label = "In phiếu",
  className,
  keyOpenPhieuIn,
  setKeyOpenPhieuIn,
  isIcon = false,
  disabled,
  srcBase64 = '', fileName = 'Phiếu ngoài trú'
}: ButtonInBase64ToPdfProps<T>) => {
  const [openPrintDialog, setOpenPrintDialog] = useState(false);
  const [base64, setBase64] = useState<string>('');
  useEffect(() => {
    setBase64(srcBase64)
  }, [srcBase64]);
    console.log(base64)
  useEffect(() => {
    keyOpenPhieuIn && setOpenPrintDialog(true);
    setKeyOpenPhieuIn?.("");
  }, [keyOpenPhieuIn]);

  return (
    <>
      {!isIcon && (
        <Button
          className={`btn-fill ${className}`}
          onClick={() => setOpenPrintDialog(true)}
          disabled={disabled}
        >
          {label}
        </Button>
      )}
      {isIcon && (
        <CustomIconButton
          variant="print"
          onClick={() => setOpenPrintDialog(true)}
        >
          <i className="bi bi-printer text-navy"></i>
        </CustomIconButton>
      )}
      {openPrintDialog && (
        <FormInPhieuDialog<T>
          fileName={fileName}
          base64={base64}
          show={openPrintDialog}
          onHide={() => setOpenPrintDialog(false)}
        />
      )}
    </>
  );
};

export default ButtonInBase64ToPdf;
